import Actions from './experience-actions';
import Api from './experience-api';
import Collection from './experience-collection';
import Model from './experience-model';
import reducer from './experience-reducer';
import sagas from './experience-sagas';
import Selectors from './experience-selectors';
import * as Utils from './experience-utils';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'experience',
  reducer,
  sagas:     [sagas],
  Selectors,
  Utils,
};
